import { z } from 'zod'
import { productTagSchema } from '@/schemas/product/product-tag'
import { productPriceSchema } from '@/schemas/product/product-price'

export const productSchema = z.object({
  groupId: z.string(),
  originId: z.string(),
  title: z.string(),
  imageUrl: z.string(),
  id: z.string(),
  subTitle: z.string().nullish(),
  weightInfo: z.string().nullish(),
  isStock: z.boolean(),
  notiCount: z.number(),
  tags: z.array(productTagSchema),
  price: productPriceSchema,
  quantityInfo: z.string().nullish(),
  volumeInfo: z.string().nullish(),
  deliveryImageUrl: z.string().nullish(),
})

export type Product = z.infer<typeof productSchema>
